import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Space, Shimmer } from '@pitchero/react-ui';
import FixtureLoadingStateRow from './row';

const FixturesLoadingState = ({ rows }) => {
  const renderRows = () => {
    const placeholderRows = [];

    for (let i = 1; i <= rows; i += 1) {
      placeholderRows.push(<FixtureLoadingStateRow key={i} />);
    }

    return placeholderRows;
  };

  return (
    <Space bottom="xxlarge" component="div">
      <Grid
        columns="1fr 1fr"
        columnGap="xlarge"
        rowGap="small"
        responsive={[{ maxWidth: 'palm', props: { columns: '1fr' } }]}
      >
        <Shimmer preset="title" height="44px" radius="22px" />
        <Shimmer preset="title" height="44px" radius="22px" />
      </Grid>
      <Space top="large" bottom="large">
        <Shimmer height="47px" radius="5px" />
      </Space>
      <Space horizontal="large" responsive={[{ maxWidth: 'palm', props: { horizontal: 'small' } }]}>
        <Grid
          columns="1fr auto auto auto 1fr"
          columnGap="medium"
          rowGap="xxxlarge"
          alignContent="center"
          alignItems="center"
          justifyContent="center"
          responsive={[{ maxWidth: 'palm', props: { columnGap: 'small', rowGap: 'large' } }]}
        >
          {renderRows()}
        </Grid>
      </Space>
    </Space>
  );
};

FixturesLoadingState.defaultProps = {
  rows: 7,
};

FixturesLoadingState.propTypes = {
  rows: PropTypes.number,
};

export default FixturesLoadingState;
